import * as React from 'react';

import * as styles from './styles.css';
import classNames from 'classnames';

interface IContentLayoutProps {
  specialistsBlock?: React.ReactNode;
  usefulLinks?: React.ReactNode;
  saleServices?: React.ReactNode;
}

export const ContentLayout: React.FC<IContentLayoutProps> = ({ specialistsBlock, usefulLinks, saleServices }) => {
  return (
    <section className={classNames('cg-container-fluid-xs', styles['container'])}>
      {specialistsBlock}
      {usefulLinks && <div className={styles['useful-links']}>{usefulLinks}</div>}
      {saleServices}
    </section>
  );
};
